import { Pagination } from '@/domain/models'
import { InvoiceEvent } from '@/domain/models/invoice/internal-company-manager/invoice-event-model'
import { InvoiceEventSearchModel } from '@/domain/models/invoice/internal-company-manager/invoice-event-search-model'

export interface InvoiceEventSearch {
  search(params: InvoiceEventSearch.Params): Promise<InvoiceEventSearch.Model>
  loader(params: InvoiceEventSearch.Params): Promise<InvoiceEventSearch.Model>
}

export namespace InvoiceEventSearch {
  export const TAB_QUERY_PARAM_NAME = 'tab'
  export const SEARCH_QUERY_PARAM_NAME = 'search'
  export const STATUSES_QUERY_PARAM_NAME = 'statuses'
  export const PAGE_QUERY_PARAM_NAME = 'page'
  export const ROWS_PER_PAGE_QUERY_PARAM_NAME = 'amount'
  export const DEFAULT_PAGE_SIZE = 20
  export const DEFAULT_ROWS_PER_PAGE_OPTIONS = [5, 20, 40, 60]
  export const Key = 'invoice-search'

  export type Model = InvoiceEventSearchModel
  export interface Params extends Pagination.Params {
    search: string | null
    statuses: InvoiceEvent.Status[] | null
    tab: TabListGroup
  }

  export enum TabListGroup {
    ALL = 'ALL',
    NOT_CLASSIFIED = 'NOT_CLASSIFIED',
    WAITING_ACTION = 'WAITING_ACTION',
    SOLVED = 'SOLVED'
  }

  export class TabEnum {
    static readonly ALL = new TabEnum(TabListGroup.ALL, 'Todas as notas')
    static readonly NOT_CLASSIFIED = new TabEnum(TabListGroup.NOT_CLASSIFIED, 'Não classificadas')
    static readonly WAITING_ACTION = new TabEnum(TabListGroup.WAITING_ACTION, 'Aguardando ação')
    static readonly SOLVED = new TabEnum(TabListGroup.SOLVED, 'Resolvidas')

    private constructor(
      public readonly value: string,
      public readonly label: string
    ) {}
  }

  export const getByTabByValue = (value: string): TabEnum => {
    return Object.values(TabEnum).find(tab => tab.value === value)
  }

  const StatusByTabEnum = {
    ALL: {
      key: 'invoice_list_all',
      value: Object.values(InvoiceEvent.Status).filter(s => s !== InvoiceEvent.Status.CREATED)
    },
    NOT_CLASSIFIED: {
      key: 'invoice_list_not_classified',
      value: [InvoiceEvent.Status.UNIDENTIFIED, InvoiceEvent.Status.FAILED]
    },
    WAITING_ACTION: {
      key: 'invoice_list_waiting_action',
      value: [InvoiceEvent.Status.PENDING]
    },
    SOLVED: {
      key: 'invoice_list_solved',
      value: [InvoiceEvent.Status.CONCILIATED, InvoiceEvent.Status.IGNORED]
    }
  }

  export const parseInvoiceEventStatus = (
    tab: InvoiceEventSearch.TabListGroup
  ): InvoiceEvent.Status[] => {
    return StatusByTabEnum[tab].value
  }
}
